import { NgModule,ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthenticationService } from './services/authentication.service';
import { PanicService} from './services/panic.service';
import { ReportService } from './services/report.service';
import { TrackerService} from './services/tracker.service';
import { DeliveryService} from './services/delivery.service';
import { VisitService} from './services/visit.service';
import { DriverService} from './services/driver.service';
import { VehicleService } from './services/vehicle.service';
import { CompanyService } from './services/company.service';
import { OrderService } from './services/order.service';
import { ProductService } from './services/product.service';
import { NotificationService } from './services/notification.service';

import { MaterialModule } from './material.module';

@NgModule({
  imports:      [ CommonModule, MaterialModule ],
  declarations: [],
  exports:      [ CommonModule, MaterialModule ],
})

export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
          ngModule: SharedModule,
          providers: [ 
              AuthenticationService, 
              PanicService, 
              ReportService,
              TrackerService,
              DriverService,
              VehicleService,
              CompanyService,
              OrderService,
              ProductService,
              NotificationService
            ]
        };
      }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/shared.module.ts